<template>
    <div class="uploadpayment_page">
       <div class="d-flex align-items-center justify-content-center __100vh_">
           <div class="__maincontent text-center">
               <div class="__paymenttitle __background_navy">
                   <p class="text-right __close"><b>X</b></p>
                   <p class="__title"> <b>Upload Proof of Payment</b></p>
               </div>
               <div class="__section">
                    <div class="d-flex flex-row align-items-center justify-content-between __sect1">
                        <img class="__lamp" src="@/assets/image/icon/lamp.svg" alt="">
                        <p class="m-0">Uploading proof of payment can fasten your payment verification process</p>
                    </div>
                    <p>Make sure that the proof of payment (receipt) show these information:</p>
                    <div class="row text-left">
                        <ul>
                            <li> Transfer Date</li>
                            <p>E.g: 11/07/2019 , 11 July 2019</p>
                            <li>Transfer Status</li>
                            <p>E.g: Success, Paid</p>
                        </ul>
                        <ul>
                            <li>Recipient Name</li>
                            <p>E.g: PT. Eximku Logistik Indonesia</p>
                            <li>Amount of Money Transfered</li>
                            <p>E.g: Rp 1,000,234.00</p>
                        </ul>
                    </div>
                    <div class="col __attachment">
                        <img src="@/assets/image/icon/attach.svg" alt="">
                        <div>
                            <button class="__background_navy">Select</button>
                        </div>
                        <p>Or<br>Drag Your File to here</p>
                        <p class="__format"> <b>File Format:</b> .PNG, .JPEG, .JPG, Max 10 MB</p>
                    </div>
                    <div>
                        <button class="__background_navy __btnUpload">Upload File</button>
                    </div>
               </div>
           </div>
       </div>
    </div>
</template>

<script>
export default {
  name: 'UploadPayment'
}
</script>



// WEBPACK FOOTER //
// src/components/payment/paynow/UploadPayment.vue